var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430.72 278.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a7209;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #499002;\n      }\n\n      .cls-3 {\n        fill: #319d00;\n      }\n\n      .cls-8 {\n        fill: rgba(255, 255, 255, 0);\n      }\n\n      .cls-9 {\n        fill: #d7e9ec;\n        opacity: .59;\n      }\n\n      .cls-9, .cls-10, .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        opacity: .06;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        fill: #97b72e;\n      }\n\n      .cls-11 {\n        opacity: .1;\n      }\n\n      .cls-5 {\n        fill: #738823;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-14 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #b7db1f;\n      }\n\n      .cls-7 {\n        fill: #a7cd35;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m243.14,161.59s29.2,15.5,85.9,9-35.1,41.9-35.1,41.9l-53,8.6-6.2-55.1,8.4-4.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 314.77,
    cy: 134,
    rx: 72,
    ry: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CakeBooked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Presents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    className: "cls-6",
    d: "m293.49,126.46h53c.5,0,.9.4.9.9v8.9c0,.5-.4.9-.9.9h-53c-.5,0-.9-.4-.9-.9v-8.9c-.1-.4.4-.9.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    className: "cls-4",
    d: "m294.99,137.26h49.8v50.8c0,2.1-1.7,3.7-3.8,3.8h-42.3c-2.1,0-3.7-1.7-3.8-3.8v-50.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-3",
    d: "m315.79,126.46h8.1v10.7h-8.1v-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    className: "cls-5",
    d: "m295.19,137.26h49.6v1.5h-49.6v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    className: "cls-2",
    d: "m315.79,138.76h8.1v53h-8.1v-53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    className: "cls-1",
    d: "m315.79,137.26h8.1v1.5h-8.1v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-7",
    d: "m344.79,139.86c0,27.7-9.3,50.2-20.8,50.2v1.8h18.4c1.3,0,2.4-1.9,2.4-4.1v-47.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-3",
    d: "m319.09,124.86s-16-17.9-20.6-9c-4.7,9,8.7,10.2,16.2,10.7h3.1l1.3-1.7h0Zm-2.2,1s-14.1-8-15.7-5.1,15.7,5.1,15.7,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-3",
    d: "m320.59,124.86s16-17.9,20.6-9c4.7,9-8.7,10.2-16.2,10.7h-3.1l-1.3-1.7h0Zm2.2,1s14.1-8,15.7-5.1-15.7,5.1-15.7,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    className: "cls-3",
    d: "m321.49,125.76s11-27.3-1.2-27.6c-14.3-.5-4.5,19.8-1.7,26.8l.2.2,2.7.6h0Zm-2-3.3s2.7-16.4-.7-16.9c-3.4-.5.7,16.9.7,16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-1",
    d: "m319.99,126.46h-5.1c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1h-5.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    className: "cls-9",
    d: "m284.82,186.49l-18.7,10.2h106.3l-22.6-10.2h-65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    className: "cls-11",
    d: "m156.74,113.09c.8-5.3-.7-9.8-4-8.9-1.2.5-2.2,1.4-2.8,2.6.6-2.5,1.5-5.6,1.7-6.8.7-3.3.3-5.1-.6-6-.5-.5-.8-.4-1,.2-1.6,4.5-5.1,20.8-5.2,24.3-.1,2.6.6,3.6,1.4,4.2.3.2.5.1.6-.3.1-.9.3-2,.4-2.9,1.1,1.5,3,2.2,4.8,1.6,2.3-.6,4-3.4,4.7-8Zm-4.1-7.1c.9-.2,2,2,1.1,7-1,5.1-2.4,6.8-3.8,6.8-1.1.1-2-1-2.4-2.1.5-3.2,1.4-6.4,2.7-9.4.9-1.5,1.6-2.2,2.4-2.3Zm8.9,4.9c3.3,1.4,5.6-.3,6.8-3.2,1.1-2.4.7-4.9-.3-5.6-.7-.6-1.7-1.1-2.7-1.3-2.2-.6-5.6,2.6-6.7,8.2s2,10,6.9,8.5c3-1,5.3-3.3,6.3-6.3.3-.8.3-1.8,0-2.6-.3-.3-.6-.2-.7.1-.9,3-2.9,6.9-6.1,7.7-2.1.5-3.7-1.6-3.5-5.5Zm.1-1c0-.2.1-.5.1-.7.8-4.2,3.3-7.4,4.3-7,.7.3.4,2.5-.4,4.5-.6,1.8-1.7,3.9-4,3.2Zm11.1-11.3c-.8,3.5-1.5,7.2-1.7,9.4-.6,5,2.3,7.2,4.8,6.6,3.1-.8,4.7-4.9,4.9-6.1.2-.8.1-1.6-.2-2.3-.3-.5-.7-.3-.8.2-.6,3.3-2,6.7-3.8,7.1-1.6.4-2.7-1.9-2.3-5,.5-3.6,1.7-8,2.4-11,.9-.5,1.9-.8,3-1,.6-.2.7-.5.3-.9-.7-.7-1.8-.9-2.7-.5.3-2.3,0-3.5-.7-4.5-.3-.4-.7-.3-.9.3-.6,1.8-1.1,3.7-1.6,5.6-1,.4-2.1.8-3.1,1.1-.6.1-.7.5-.2.9.6.3,1.7.4,2.6.1Zm21.3-7.2c1.3-3.4.4-5.5-1.7-6.8-2-.9-4.3-.5-5.8,1-2,2.1-3.3,4.7-3.9,7.5-.1.4.1.6.6.6,1.7-.1,2.7-1.5,3.5-3.3,1.2-2.8,2.9-5.7,4.7-4.6,2.1,1.3.1,7.6-7.4,12.4-.5.3-.4.6-.1.8,2.7,1.8,4.5-1.2,6.4-.6,1.5.5,1.1,3.6-.1,6.4-1.3,3.2-4.1,5.7-6.3,5-1.6-.5-2.4-3.2-1.3-6.9.1-.4-.1-.6-.5-.5-1.4.6-2.4,1.9-2.4,3.4-.2,2.4,1.3,4.7,3.7,5.4,2.9.9,7.5-.5,9.6-5.4,1.8-4.3,1.4-7.8-1-8.9-.6-.2-1.3-.3-2-.3,1.6-1.2,3-3.1,4-5.2Zm13.4-8.5c-.2-1.2-1.1-2.2-2.3-2.5-1.3-.4-2.7-.1-3.8.7-1.5,1-5.2,4.3-7,11.7-1.8,7.6.2,13.3,4.1,14.3,3.3.8,6.8-.9,8.1-6.4,1.3-5.6-.7-8.5-3.6-9.3-2-.6-4.1.1-5.5,1.7,1.8-7.1,5.4-11,7-11.2.6-.1.5,1.9.4,3.8-.2,2.2.6,3.8,1.8,4.2.5.2.7.1.8-.4.5-2.3.4-4.5,0-6.6Zm-10.5,18.1c-.1-5.5,3.6-8.4,5.3-8.2,1.7.3,2.3,3.2,1.6,6.9-.7,3.9-3,6.5-4.7,6-.9-.3-2.2-1.8-2.2-4.7Zm25.9-23.7c.4-.1.5-.3.2-.6-.8-1.2-2.3-1.7-3.7-1.2-2,.6-5.3,2.8-8.9,3.7-.4.1-.5.3-.3.6.2.4.6.7,1,1-.8,2.6-1.4,5.2-1.9,7.8-.4,2.5.5,3.7,1.3,4.2.4.2.6.2.8-.3,1-2.7,3.2-4.5,4.7-4.2,1.5.3,2.1,3.5,1.2,7.3-.9,3.6-3.7,7.1-5.9,6.5-1.8-.5-2.6-3.7-1.6-7,.1-.4-.1-.6-.4-.5-1.4.5-2.4,1.9-2.4,3.4-.4,2.6,1.3,5,3.8,5.6,3.4.7,7.8-1.5,9.3-7,1.7-6.1-.3-8.7-2.7-9.6-1.8-.5-3.8-.2-5.3,1,.7-2.4,1.4-4.7,2.1-7,.2-.1.4-.1.6-.2,2.3-1,4.7-2.5,8.1-3.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    className: "cls-10",
    d: "m199.57,134.9c-8.9-7.4-18.3-13.2-19.6-11.1-.4.6.4,2.2,2,4.2-3.9-3.5-8.7-8-10.7-9.8-5.3-4.8-8.9-7-11.4-8-1.2-.5-1.4-.3-.5.6,6.6,6.5,33,29.8,39.2,34.6,4.5,3.5,7,4.7,8.8,5.3.7.2.7,0,0-.5-1.5-1.3-3.3-2.7-4.8-4,3.8,1.7,6.5,2.2,7.3.9.9-1.4-2.7-5.8-10.3-12.2Zm-16.6-8.7c.5-.5,5.6,2.3,13.7,9.3,8.3,7.2,10,9.9,8.8,10.3-.9.4-3.7-.9-6-2.3-5.1-4.2-9.9-8.7-14.5-13.5-2-2.3-2.5-3.4-2-3.8Zm17,4.4c5.6,1.1,4.6-1.9.6-6.1-3.4-3.6-8.1-6.8-10.3-7.6-1.6-.6-3.3-1-5.1-1.1-3.1-.2-.5,4.9,8.7,13s19.9,13.2,21.7,9.9c1.1-2-1.3-6.2-5.5-10.3-1.4-1.4-3-2.6-4.7-3.5-.8-.3-.9-.1-.3.4,4.6,4.4,9.8,10.2,8.2,12-1,1.2-6.4-1.3-13.3-6.7Zm-1.6-1.3c-.4-.3-.8-.7-1.2-1-6.8-5.9-10.3-11-8.6-10.6,1.1.2,4.9,3.3,7.7,6.2,2.6,2.5,5.4,5.7,2.1,5.4h0Zm-10.2-18.3c5.6,5,11.6,10.2,15.3,13.2,8.4,6.9,15.1,9.3,16.3,7.7,1.5-1.8-4.5-7.9-6.6-9.6-1.3-1.2-2.8-2.2-4.4-3.1-1.2-.6-1.2-.2-.3.5,5.4,4.7,10.2,9.6,9.3,10.6-.8.9-5.9-1.9-11.2-6.3-6.1-5.1-13-11.3-17.7-15.6,0-.8.3-1.6.9-2.1.2-.4-.3-.8-1.3-1.2-1.2-.4-2.8-1-3.4.1-2.6-2.4-5.6-4.4-8.8-5.9-1-.5-1.3-.3-.4.6,1.5,1.5,4.8,4.6,8.7,8.1-.1.8-.5,1.6-1,2.3-.3.3.1.8,1.4,1.3,1.1,0,2.7.2,3.2-.6h0Zm6.7-15.3c-5-5-9.7-7.7-13.8-8.9-3.3-.9-4.8.4-3.7,2.8s5.7,7.6,10,11.3c.7.6,1.2.9,1.6.6,1.3-.6-.1-2.7-2.8-5.5-4-4.1-7.5-8.5-3.9-7.5,4.3,1.2,13.8,10.4,15.5,18.8.2.6.7,1,1.4,1.2,5.8,1.8,2-2.8,4.8-2.4,2.3.3,7.4,4.6,11.5,8.8,4.6,4.7,6.5,8.8,3.2,8.5-2.4-.2-8-3.8-13.6-9-.6-.5-1.1-.7-1.2-.5-.5.7.8,2.8,3.9,5.3,2.6,2.2,8.5,5.9,13.1,6.4,4.3.5,6.1-2.6-.9-9.9-6.1-6.4-12.7-11-16.9-11.9-.8-.2-1.6-.1-2.3.2-1.5-3.1-3.5-5.9-5.9-8.3Zm-3.1-15.2c-2.9-1.8-5-2.7-6.6-2.9-1.4-.2-2.7.3-2.3,1.9.4,1.8,3,7.2,14.8,17.8,12.1,10.9,24.2,18.2,29.6,18.5,4.6.3,4.6-3-4-10.8-8.9-7.9-16.1-11.5-20.2-11.9-3-.3-3.5,1.3-2,3.7-11.1-10-14.8-16.3-13.8-17,.4-.3,3.9,2.4,7.2,5,3.8,3.1,7.4,5.1,9.3,5.3.7.1.7-.1-.1-.8-3.8-3.1-7.7-6.1-11.9-8.8Zm23,27.4c-10.1-7.6-11.9-12.5-9.8-12.6s7.9,3.7,14,9c6.3,5.5,8.9,9.6,6.4,9.4-1.4,0-5.4-1.8-10.6-5.8Zm-18.8-39c.2-.3-.1-.5-.9-.9-2.9-1.4-5-1.8-5.5-.7-.7,1.3.1,5.2-1.6,7.3-.2.3.1.6.8.9.8.4,1.7.8,2.7,1.1,4.6,4.3,8.9,8.2,12.4,11.2,4.1,3.5,7.1,4.9,8.8,5.4.7.2.9.1.2-.5-3.9-4-5.3-7-3.2-6.9,1.9.1,8.3,4.2,14.3,9.7,5.7,5.2,9.5,10.7,6.3,10.5-2.4-.2-9-4.4-14.2-9.2-.6-.5-1.2-.8-1.2-.5-.3.8.5,2.6,3.9,5.3,3.5,2.8,9.5,6.5,13.6,6.6,4.4.1,4.5-4-4.1-12-9.5-8.8-16.1-11.8-19.9-12.5-2.2-.4-3.9.5-3.1,2.7-3.7-3.5-7.3-6.9-10.7-10.2.1-.1.2-.3.2-.4.4-2-.2-4.7,1.2-6.9Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 5.9,
    width: 430,
    height: 273
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent3);
export default __webpack_public_path__ + "static/media/Present3.639ce29ac899ac191209e4e6281b13ae.svg";
export { ForwardRef as ReactComponent };